export function OutlineUnlockIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0163 11.002H6.01145C4.90865 11.002 4.01465 11.896 4.01465 12.9988V19.0036C4.01465 20.1064 4.90865 21.0004 6.01145 21.0004H18.0163C19.1191 21.0004 20.0131 20.1064 20.0131 19.0036V12.9988C20.0131 11.896 19.1191 11.002 18.0163 11.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0132 8.00161C17.0132 5.2416 14.7764 3 12.0116 3C9.24681 3 7.01001 5.2368 7.01001 8.00161V11.0016H10.01V8.00161C10.01 6.89761 10.9076 6.00001 12.0116 6.00001C13.1156 6.00001 14.0132 6.89761 14.0132 8.00161H17.0132Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0161 15V17.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
